import { Component, OnInit, Input } from '@angular/core';
import { JwtAuthService } from '../../../shared/services/auth/jwt-auth.service';
import { LayoutService } from '../../services/layout.service';

interface IMenuItem {
  name: string;
  type?: string;
  tooltip?: string;
  icon?: string;
  state?: string;
  role_access?: string[];
  showOnEmpresaConsultoria?: boolean;
  sub?: IMenuItem[];
}

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.template.html'
})
export class SidenavComponent implements OnInit{
  @Input('items') public menuItems: any[] = [];
  @Input('hasIconMenu') public hasIconTypeMenuItem: boolean;
  @Input('iconMenuTitle') public iconTypeMenuTitle: string;

  constructor(
    private jwtAuthService: JwtAuthService,
    public layout: LayoutService
  ) {}
  ngOnInit() {
    console.log('SidenavComponent.ngOnInit ');
    // this.removeElementFromObjectArray('LIBERACAO');
    console.log(this.jwtAuthService?.item$?.value?.roles);
    // if(this.jwtAuth.isRoleAuthorized(this.jwtAuth?.item$?.value, 'ROLE_ROOT') ){
    //   console.log('With Great Power Comes Great Responsibility!');
    // }else {
    //   this.removeElementFromObjectArray('LIBERACAO');
    //   this.removeElementFromObjectArray('ACCESS');
    // }
    console.log(this.menuItems);
  }

  getMenuItems(): IMenuItem[] {
    const userRoles = this.getUserRoles(); // obtenha roles do usuário autenticado
    return this.menuItems.filter(item => {
      if (item.showOnEmpresaConsultoria !== undefined && item.showOnEmpresaConsultoria !== this.layout.layoutConf?.isEmpresaConsultoria) {
        return false;
      }
      // se item tem role_access definido, verifica se usuário tem ao menos uma role correspondente
      if (item.role_access && Array.isArray(item.role_access) && item.role_access.length > 0) {
        return item.role_access.some(role => userRoles.includes(role));
      }
      // se não tem role_access ou está vazio, libera
      return true;
    }).map(item => {
      // aplica filtro recursivo nos sub-itens
      if (item.sub && item.sub.length > 0) {
        item.sub = item.sub.filter(subItem => {
          if (subItem.showOnEmpresaConsultoria !== undefined && subItem.showOnEmpresaConsultoria !== this.layout.layoutConf?.isEmpresaConsultoria) {
            return false;
          }
          if (subItem.role_access && Array.isArray(subItem.role_access) && subItem.role_access.length > 0) {
            return subItem.role_access.some(role => userRoles.includes(role));
          }
          return true;
        }).map(subItem => {
          // filtro nível 3 se existir
          if (subItem.sub && subItem.sub.length > 0) {
            subItem.sub = subItem.sub.filter(subSubItem => {
              if (subSubItem.showOnEmpresaConsultoria !== undefined && subSubItem.showOnEmpresaConsultoria !== this.layout.layoutConf?.isEmpresaConsultoria) {
                return false;
              }
              if (subSubItem.role_access && Array.isArray(subSubItem.role_access) && subSubItem.role_access.length > 0) {
                return subSubItem.role_access.some(role => userRoles.includes(role));
              }
              return true;
            });
          }
          return subItem;
        });
      }
      return item;
    });
  }

  private getUserRoles(): string[] {
    const user = this.jwtAuthService.getUser(); 
    return user?.roles ?? [];
  }

  filterSubItems(menuItems: any[], restrictedSubItems: string[]): any[] {
    return menuItems.map(item => {
      if (item.sub && item.sub.length > 0) {
        item.sub = item.sub.filter((subItem: { name: string }) => !restrictedSubItems.includes(subItem.name));
      }
      return item;
    });
  }

  removeElementFromObjectArray(key: string) {
    this.menuItems.forEach((value,index)=>{
        if(value.name === key) this.menuItems.splice(index,1);
    });
} 

  // Only for demo purpose
  addMenuItem() {
    this.menuItems.push({
      name: 'ITEM',
      type: 'dropDown',
      tooltip: 'Item',
      icon: 'done',
      state: 'material',
      sub: [
        {name: 'SUBITEM', state: 'cards'},
        {name: 'SUBITEM', state: 'buttons'}
      ]
    });
  }

 
}